import { AppLayout } from "../shared";
import ClubContent from "../MasterOrg/ClubContent";

const ClubContent_layout = ({ props, setIsLoaded }) => (
  <AppLayout props={props}>
    <ClubContent props={props} setIsLoaded={setIsLoaded} />
  </AppLayout>
);

export default ClubContent_layout;
